export default __webpack_public_path__ + "static/media/default-profile-picture.deeebbe3.png";